import {
  FormField, LoadingBubbles, SelectBox, Text,
} from '@domain-group/suit-theme'

import type { ProviderPriceListModel, ServiceProductModel } from '@models/types'
import type { UseNewOrderPayload } from '@modals/NewOrderModal'

interface ProductSelectorProps {
  callbacks: {
    selectServiceProductId: UseNewOrderPayload['callbacks']['selectServiceProductId'],
  },
  currentPriceList: ProviderPriceListModel,
  loadingPriceLists: boolean,
  selectedServiceProductId: number,
  serviceProducts: ServiceProductModel[],
}

const ProductSelector = (props: ProductSelectorProps) => {
  const {
    callbacks: {
      selectServiceProductId,
    },
    currentPriceList,
    loadingPriceLists,
    selectedServiceProductId,
    serviceProducts,
  } = props

  return (
    <FormField
      label="Select Product"
      labelProps={{ flexShrink: 0, width: 'auto' }}
      labelRight={loadingPriceLists && (
        <LoadingBubbles color="blue" style={{ marginLeft: 'auto', width: 'auto' }} />
      )}
      marginTop="large"
    >
      {/* SelectBox doesn't accept a test id, so wrap it */}
      <div data-test-id="productSelector">
        <SelectBox
          callbacks={{
            selectItem: (item: { key: number }) => selectServiceProductId(item.key),
          }}
          items={serviceProducts.map(serviceProduct => ({ key: serviceProduct.id, title: serviceProduct.title }))}
          selectedItemKey={selectedServiceProductId}
          style={{ zIndex: 14 }}
        />
      </div>

      {!!currentPriceList.id && (
        <Text color="lightGrey" fontSize="xxsmall" marginTop="small" marginLeft="auto">
          #{currentPriceList.id} - {currentPriceList.title}
        </Text>
      )}
    </FormField>
  )
}

export default ProductSelector
